export const CHAR_LIMIT = 1000;
